/**
 * Method to track algolia specific events.
 * eventNames must be specific, for a list of names use the link below
 * 
 * @see https://www.algolia.com/doc/api-client/methods/insights/
 * 
 * @param {string} insightMethod - A specific event name to categorize the type of event
 * @param {object} params - Parameters for the specified event. The params will be different depending on the event
 */
export const trackAlgoliaEvent = (insightMethod, params) => {
  if (typeof window.aa === 'function') {
    const globals = window.__GLOBALS__
    const env = globals && globals.config && globals.config.environment

    window.aa(insightMethod, {
      index: env === 'production' ? 'products' : 'products_dev',
      ...params
    })
  }
}